import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (this.content !== '')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "block-text",
        innerHTML: this.content
      }, null, 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}